import { createContext, useContext, useState } from "react";

const dict = {
  it: {
    nav: {
      oasi: "L'Oasi",
      comfort: "Comfort",
      recensioni: "Recensioni",
      galleria: "Galleria",
      posizione: "Posizione",
      cta: "Prenota",
    },
    hero: {
      eyebrow: "Casa per vacanze · Borgetto, Palermo",
      lines: ["La tua oasi", "privata nel", "cuore della Sicilia"],
      sub: "Una villa immersa nella quiete della campagna siciliana: piscina, giardini e tramonti che non dimentichi.",
      rating: "5,0 su Google",
      reviews: "9 recensioni",
      cta1: "Richiedi disponibilità",
      cta2: "Scrivici su WhatsApp",
      scroll: "Scorri",
    },
    marquee: ["Private Oasis Villa", "Borgetto · Sicilia", "Un'oasi di quiete", "5,0 su Google"],
    intro: {
      eyebrow: "L'Oasi",
      title: "Non una casa vacanze.",
      titleAccent: "Un'oasi privata.",
      p1: "Tra ulivi e colline, a pochi minuti da Palermo, Private Oasis Villa è un rifugio pensato per chi cerca silenzio, spazio e bellezza. Ogni dettaglio è curato per farti sentire a casa — solo meglio.",
      p2: "Giornate scandite dal sole: colazione all'ombra, pomeriggi a bordo piscina, cene all'aperto sotto il cielo di Sicilia.",
      stat1n: "5,0",
      stat1l: "Valutazione Google",
      stat2n: "9",
      stat2l: "Recensioni verificate",
      chip: "Cosa dicono gli ospiti",
    },
    comfort: {
      eyebrow: "Comfort & Servizi",
      title: "Tutto ciò che serve per non pensare a nulla",
      listTitle: "I comfort della villa",
      items: [
        "Piscina privata",
        "Giardino e terrazze",
        "Cucina attrezzata",
        "Wi-Fi gratuito",
        "Aria condizionata",
        "Parcheggio privato",
        "Barbecue all'aperto",
        "Biancheria e asciugamani",
      ],
      quote: "Attenti a ogni minimo dettaglio…",
      quoteSub: "La cura è il nostro vero lusso.",
      chipPool: "Piscina privata",
      chipNature: "Il giardino",
      chipInside: "Massimo confort",
    },
    services: {
      eyebrow: "Servizi esclusivi",
      title: "Per i nostri ospiti, qualcosa in più",
      sub: "Dall'aeroporto al mare, fino alla tavola: servizi pensati per vivere la Sicilia senza pensieri.",
      note: "Su richiesta: scrivici su WhatsApp e organizziamo tutto per il tuo soggiorno.",
      items: [
        { t: "Noleggio auto", d: "Su richiesta" },
        { t: "Trasferimento aeroportuale", d: "Da e per aeroporti Falcone-Borsellino (Palermo) e Vincenzo Florio (Trapani)" },
        { t: "Escursioni in catamarano", d: "Previo disponibilità" },
        { t: "Noleggio barche", d: "Senza patente" },
        { t: "Experience food siciliana", d: "Degustazione e cene esclusive" },
      ],
    },
    reviews: {
      eyebrow: "Recensioni verificate",
      title: "Gli ospiti lo dicono meglio di noi",
      based: "basata su 9 recensioni Google",
      readAll: "Leggi tutte le recensioni",
      source: "Recensione Google",
      quotes: [
        "Bellissimo soggiorno, villa magnifica.",
        "La proprietà è squisita e attenta ad ogni minimo dettaglio…",
        "Do 5 stelle perché purtroppo mi è consentito solo questo numero.",
      ],
    },
    gallery: {
      eyebrow: "Galleria",
      title: "Uno sguardo all'oasi",
    },
    location: {
      eyebrow: "Posizione",
      title: "Contrada Mazzarca, Borgetto",
      sub: "Palermo · Sicilia",
      p: "Nella verde campagna di Borgetto, alle spalle di Palermo: la Sicilia dei borghi, degli ulivi e dei tramonti, con la città, Monreale e le spiagge della costa nord a portata d'auto.",
      address: "Contrada Mazzarca, snc · 90042 Borgetto (PA)",
      maps: "Apri in Google Maps",
      chip: "Borgetto · Palermo · Sicilia",
    },
    booking: {
      eyebrow: "Prenota",
      title: "Richiedi la disponibilità",
      p: "Scrivici i tuoi date: rispondiamo in fretta, spesso direttamente su WhatsApp.",
      whatsapp: "Scrivici su WhatsApp",
      call: "Chiama ora",
      formName: "Nome e cognome",
      formEmail: "Email",
      formPhone: "Telefono",
      formCheckin: "Arrivo",
      formCheckout: "Partenza",
      formGuests: "Ospiti",
      formMessage: "Messaggio (opzionale)",
      formSubmit: "Invia richiesta",
      formSending: "Invio…",
      guestUnit: "ospiti",
      toastOk: "Richiesta inviata! Ti risponderemo al più presto.",
      toastErr: "Qualcosa è andato storto. Riprova o scrivici su WhatsApp.",
      whatsappMsg: "Ciao! Vorrei richiedere la disponibilità per Private Oasis Villa.",
    },
    footer: {
      tag: "Casa per vacanze · Borgetto, Sicilia",
      rights: "Tutti i diritti riservati.",
    },
  },
  en: {
    nav: {
      oasi: "The Oasis",
      comfort: "Comfort",
      recensioni: "Reviews",
      galleria: "Gallery",
      posizione: "Location",
      cta: "Book now",
    },
    hero: {
      eyebrow: "Holiday home · Borgetto, Palermo",
      lines: ["Your private", "oasis in the", "heart of Sicily"],
      sub: "A villa set in the quiet of the Sicilian countryside: private pool, gardens and sunsets you will never forget.",
      rating: "5.0 on Google",
      reviews: "9 reviews",
      cta1: "Check availability",
      cta2: "Message us on WhatsApp",
      scroll: "Scroll",
    },
    marquee: ["Private Oasis Villa", "Borgetto · Sicily", "A private oasis", "5.0 on Google"],
    intro: {
      eyebrow: "The Oasis",
      title: "Not a holiday home.",
      titleAccent: "A private oasis.",
      p1: "Between olive groves and hills, minutes from Palermo, Private Oasis Villa is a retreat designed for those seeking silence, space and beauty. Every detail is curated to make you feel at home — only better.",
      p2: "Days set by the sun: breakfast in the shade, afternoons by the pool, dinners outdoors under the Sicilian sky.",
      stat1n: "5.0",
      stat1l: "Google rating",
      stat2n: "9",
      stat2l: "Verified reviews",
      chip: "What our guests say",
    },
    comfort: {
      eyebrow: "Comfort & Services",
      title: "Everything you need to switch off",
      listTitle: "Villa comforts",
      items: [
        "Private pool",
        "Garden and terraces",
        "Equipped kitchen",
        "Free Wi-Fi",
        "Air conditioning",
        "Private parking",
        "Outdoor barbecue",
        "Linens and towels",
      ],
      quote: "Attentive to every little detail…",
      quoteSub: "Care is our true luxury.",
      chipPool: "Private pool",
      chipNature: "The garden",
      chipInside: "Maximum comfort",
    },
    services: {
      eyebrow: "Exclusive services",
      title: "A little extra for our guests",
      sub: "From the airport to the sea, to the table: services designed so you can enjoy Sicily with zero worries.",
      note: "On request: message us on WhatsApp and we'll arrange everything for your stay.",
      items: [
        { t: "Car rental", d: "On request" },
        { t: "Airport transfer", d: "To and from Falcone-Borsellino (Palermo) & Vincenzo Florio (Trapani) airports" },
        { t: "Catamaran excursions", d: "Subject to availability" },
        { t: "Boat rental", d: "No license required" },
        { t: "Sicilian food experience", d: "Exclusive dining and tasting" },
      ],
    },
    reviews: {
      eyebrow: "Verified reviews",
      title: "Our guests say it best",
      based: "based on 9 Google reviews",
      readAll: "Read all reviews",
      source: "Google review",
      quotes: [
        "Bellissimo soggiorno, villa magnifica.",
        "La proprietà è squisita e attenta ad ogni minimo dettaglio…",
        "Do 5 stelle perché purtroppo mi è consentito solo questo numero.",
      ],
    },
    gallery: {
      eyebrow: "Gallery",
      title: "A glimpse of the oasis",
    },
    location: {
      eyebrow: "Location",
      title: "Contrada Mazzarca, Borgetto",
      sub: "Palermo · Sicily",
      p: "In the green countryside of Borgetto, just behind Palermo: the Sicily of hamlets, olive groves and sunsets, with the city, Monreale and the beaches of the northern coast within easy reach.",
      address: "Contrada Mazzarca, snc · 90042 Borgetto (PA)",
      maps: "Open in Google Maps",
      chip: "Borgetto · Palermo · Sicily",
    },
    booking: {
      eyebrow: "Book",
      title: "Check availability",
      p: "Send us your dates: we reply quickly, often directly on WhatsApp.",
      whatsapp: "Message us on WhatsApp",
      call: "Call now",
      formName: "Full name",
      formEmail: "Email",
      formPhone: "Phone",
      formCheckin: "Check-in",
      formCheckout: "Check-out",
      formGuests: "Guests",
      formMessage: "Message (optional)",
      formSubmit: "Send request",
      formSending: "Sending…",
      guestUnit: "guests",
      toastOk: "Request sent! We will get back to you shortly.",
      toastErr: "Something went wrong. Please try again or message us on WhatsApp.",
      whatsappMsg: "Hello! I would like to check availability for Private Oasis Villa.",
    },
    footer: {
      tag: "Holiday home · Borgetto, Sicily",
      rights: "All rights reserved.",
    },
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState("it");
  return (
    <LangContext.Provider value={{ lang, setLang, t: dict[lang] }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
export const WHATSAPP_URL = "https://wa.me/393801466883";
export const PHONE_TEL = "tel:+393801466883";
export const PHONE_LABEL = "380 146 6883";
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Private+Oasis+Villa+Contrada+Mazzarca+Borgetto+PA";
